import * as React from 'react';

import { enumLoadWeightType } from '@rematter/modules/trade/types/load';

import { LineItemErrors } from '../../_shared/LineItems';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

export const usePurchaseOrderMaterialsErrors = (
  errors: Record<string, string>,
) => {
  const t = useTranslations();

  return React.useMemo(
    () =>
      Object.entries(errors)
        .filter(([errorKey]) => errorKey.startsWith('lineItem|'))
        .reduce(
          (acc, [errorKey]) => {
            const [, lineItemId, field] = errorKey.split('|');

            acc[lineItemId] = {
              itemId:
                acc[lineItemId]?.itemId ??
                (field === 'itemId'
                  ? t.formErrors.purchaseOrders.materials.itemId.required
                  : undefined),
              weights: {
                [enumLoadWeightType.Gross]: undefined,
                [enumLoadWeightType.Tare]: undefined,
                [enumLoadWeightType.Net]:
                  acc[lineItemId]?.weights?.net ??
                  (field === 'weights.net'
                    ? t.formErrors.purchaseOrders.materials.quantity.required
                    : undefined),
              },
            };
            return acc;
          },
          {} as Record<string, LineItemErrors>,
        ),
    [errors, t],
  );
};
